import { render, staticRenderFns } from "./SimpleExchangeRateWidget.vue?vue&type=template&id=6c0213c7&scoped=true&"
import script from "./SimpleExchangeRateWidget.vue?vue&type=script&lang=js&"
export * from "./SimpleExchangeRateWidget.vue?vue&type=script&lang=js&"
import style0 from "./SimpleExchangeRateWidget.vue?vue&type=style&index=0&id=6c0213c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0213c7",
  null
  
)

export default component.exports